var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-content-box',{staticClass:"summary",class:{'is-grow': _vm.grow, 'is-fixed': _vm.fixed},attrs:{"not-padded":true,"icon":_vm.icon,"title":_vm.title}},[_c('div',{staticClass:"summary-items"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }